import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import { useUserCartStore } from "../../../../../features/UserCart/helpers/useUserCartStore";
import { CartFlowModals } from "../../../../../features/UserCart/ui/CartFlowModals";
import useBodyScrollLock from "../../../../../hooks/useBodyScrollLock";
import CartIcon from "../../../../Icons/CartIcon";
import MainHeaderStore from "../../../stores/MainHeaderStore";
import s from "./Cart.module.scss";

type Props = {
  headerStore: MainHeaderStore;
  isMainPage: boolean;
};

export const Cart: React.FC<Props> = observer(({ headerStore, isMainPage }) => {
  const { lock, unlock } = useBodyScrollLock();
  const cartStore = useUserCartStore();

  const toggleCart = () => {
    headerStore.setCartVisible(!headerStore.isCartVisible);
  };

  useEffect(() => {
    headerStore.isCartVisible ? lock() : unlock();
  }, [headerStore.isCartVisible]);

  return (
    <div className={s.wrapper}>
      <div
        className={clsx(s.cart, isMainPage && s.cart_main)}
        onClick={toggleCart}
      >
        <CartIcon color={isMainPage ? "#fff" : "#0D0C21"} />
        {cartStore.cart.length > 0 && (
          <div className={s.cart_amount}>
            <p>{cartStore.cart.length}</p>
          </div>
        )}
      </div>
      <CartFlowModals />
    </div>
  );
});
